
import {computed, defineComponent, ref} from "vue";
import {useStore} from "vuex";
import {LIST_GENRES_FROM_API} from "@/store/movies_actions";
import router from "@/router";

export default defineComponent({
  name: "AppHeader",
  setup() {
    const store = useStore();
    store.dispatch(LIST_GENRES_FROM_API);
    const genres = computed(() => store.state.genres);
    const showMenu = ref(false);
    const searchTerm = ref()

    const toggleMenu = (forceClose = false) => showMenu.value = forceClose === true
        ? false
        : !showMenu.value;

    const search = () => {
      if (searchTerm.value) {
        toggleMenu(true)
      }
      return searchTerm.value
          ? router.push({name: 'search', params: {term: searchTerm.value}})
          : null;
    };

    return {
      genres,
      showMenu,
      search,
      searchTerm,
      toggleMenu
    }
  }
}
)
